<template>
  <Modal
    ref="updateProjectModal"
    :width="'60%'"
    :title="'Edit Project Information'"
    @closed="clearData"
  >
    <template #modal-main>
      <div class="project-settings container">
        <div class="row mb-3">
          <div class="col-6 settings__control-group">
            <label>Name</label>
            <input
              v-model="name"
              class="select"
              type="text"
            >
          </div>
          <div class="col-6 settings__control-group">
            <label>Version</label>
            <input
              v-model="version"
              class="select"
              type="text"
            >
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6 settings__control-group">
            <label>Author</label>
            <input
              v-model="author"
              class="select"
              type="text"
            >
          </div>
          <div class="col-6 settings__control-group">
            <label>Email</label>
            <input
              v-model="email"
              class="select"
              type="text"
            >
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12 settings__control-group">
            <label>Keywords (comma separated)</label>
            <input
              v-model="keywords"
              class="select"
              type="text"
            >
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12 settings__control-group">
            <label>Documentation</label>
            <input
              v-model="help_url"
              class="select"
              type="text"
            >
          </div>
        </div>

        <div class="row mt-6">
          <div class="col-6 settings__control-group">
            <label>Description</label>
            <textarea
              v-model="description"
              rows="7"
              cols="50"
            />
          </div>
          <div class="col-6 settings__control-group">
            <label>Project Image</label>
            <DragDropImageUploader @update:image="ImageChanged" />
          </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="footer">
        <button
          class="button button-sm"
          :class="{'button-spinner': isLoading}"
          :disabled="isLoading ? true : false"
          @click="applyChanges"
        >
          {{ 'Apply Changes' }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import DragDropImageUploader from '@/components/DragDropImageUploader.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

export default {
  name: 'ProjectUpdateModal',
  components: {
    Modal,
    DragDropImageUploader,
  },
  props: {
    project: {
      type: Object,
      default: () => {},
    },
  },
  emits: {
    'edit-project': null,
    'edited-project': null,
  },
  data() {
    return {
      name: '',
      description: '',
      author: '',
      email: '',
      version: '',
      help_url: '',
      keywords: '',
      image: null,
      dataConnect: new DatastoreConnect(),
      isLoading: false,
    };
  },
  watch: {
    project(d) {
      if (d) {
        this.name = this.project.name;
        this.description = this.project.description;
        this.author = this.project.author;
        this.email = this.project.email;
        this.version = this.project.version;
        this.help_url = this.project.help_url;
        this.keywords = this.project.keywords;
      }
    },
  },
  methods: {
    showModal() {
      if (this.project) {
        this.name = this.project.name;
        this.description = this.project.description;
        this.author = this.project.author;
        this.email = this.project.email;
        this.version = this.project.version;
        this.help_url = this.project.help_url;
        this.keywords = this.project.keywords;
      }
      this.$refs.updateProjectModal.showModal();
    },
    ImageChanged(img) {
      this.image = img;
    },
    clearData() {
      this.name = "";
      this.description = "";
      this.author = "";
      this.email = "";
      this.version = "";
      this.help_url = "";
      this.keywords = "";
    },
    closeModal() {
      this.clearData();
      this.$refs.updateProjectModal.closeModal();
    },
    async applyChanges() {
      const params = {
        name: this.name,
        description: this.description,
        project_id: this.project.id,
        author: this.author,
        email: this.email,
        help_url: this.help_url,
        version: this.version,
        image: this.image,
        keywords: this.keywords,
      };

      await this.updateProject(params);

      this.$emit('edited-project', this.project);

      this.closeModal();
    },
    async updateProject(params) {
      this.isLoading = true;

      await this.dataConnect.UploadResourceImage(params)
        .then((data) => {
          if (data.result) {
            console.log(data.result);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      await this.dataConnect.updateProject(params)
        .then((data) => {
          if (data.result) {
            this.$emit('edited-project', data.result);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.project-edit-modal {
  width: 80%;
}

.project-settings {
  padding: 0.75rem 3rem;
}

// @media (min-width: $breakpoint-sm) {
//   .project-settings  {
//     min-width: 820px;
//   }
// }

.form-row {
  display: flex;
  flex-direction: row;
}
.footer {
  display: flex;
  flex-direction: row;
  padding: 0.75rem 3rem;
  justify-content: flex-end;
}

.close-button {
  @include themify() {
    background: themed('button-secondary');
    color: themed('button-secondary-text');
  }
}
</style>
